import { Component } from '@angular/core';
@Component({
    selector: 'app-show-user-no-rights',
    templateUrl: './show-user-no-rights.component.html',
    styleUrls: ['./show-user-no-rights.component.scss'],
    standalone: false
})
export class ShowUserNoRightsComponent {}
